import { User } from "../types/user";

export const canAccessDeals = (user: User | null): boolean => {
  if (!user) return false;

  // Admin users (superadmin, admin) can always access deals
  if (user.isAdmin) return true;

  // For non-admin users, check userRole
  // superuser can access deals, but regular user cannot
  if (user.userRole === "superuser") return true;
  if (user.userRole === "user") return false;

  // Default to false for safety
  return false;
};
